import { CartLinesUpdateEvent } from '@shopify/events';

const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function fmt(cents) {
  const v = Number(cents) / 100;
  const s = Number.isInteger(v)
    ? v.toLocaleString('sv-SE')
    : v.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return s + ' kr';
}

async function refreshCart() {
  const cartItems = document.querySelector('cart-items-component');
  if (cartItems) {
    await customElements.whenDefined('cart-items-component');
    if (typeof cartItems.fetchCartData === 'function') return cartItems.fetchCartData();
  }
  const res = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  return res.json();
}

// Digitala produkter: max 1 st per produkt i varukorgen.
async function capQuantities(ids) {
  try {
    const res = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    const cart = await res.json();
    const updates = {};
    let n = 0;
    (cart.items || []).forEach((it) => {
      if (it.quantity > 1 && (!ids || ids.includes(String(it.variant_id)))) { updates[it.key] = 1; n++; }
    });
    if (!n) return false;
    await fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    });
    return true;
  } catch (e) { return false; }
}

function init(root) {
  if (root.dataset.mmReady) return;
  root.dataset.mmReady = '1';
  const form = root.querySelector('.mm-buy__form');
  const btn = root.querySelector('.mm-buy__btn');
  if (!form || !btn) return;
  const label = btn.dataset.label || 'Lägg i varukorgen';
  const eyebrow = root.querySelector('[data-mm-eyebrow]');
  const sticky = root.querySelector('.mm-sticky');
  const sPrice = root.querySelector('[data-mm-sticky-price]');
  const sName = root.querySelector('[data-mm-sticky-name]');
  const sBtn = root.querySelector('.mm-sticky__btn');
  let busy = false;

  function state() {
    const plan = root.querySelector('input[name="mm-plan"]:checked') || root.querySelector('input[name="mm-plan"]');
    if (!plan) return null;
    const key = plan.dataset.key;
    root.querySelectorAll('.mm-pills, .mm-ups').forEach((g) => { g.hidden = g.dataset.for !== key; });
    const pv = root.querySelector('.mm-pills[data-for="' + key + '"] input:checked');
    const v = pv || plan;
    const extras = Array.from(root.querySelectorAll('.mm-ups[data-for="' + key + '"] input:checked'));
    const addon = root.querySelector('input[name="mm-addon"]');
    if (addon && addon.checked) extras.push(addon);
    const ids = [];
    let total = Number(v.dataset.price);
    extras.forEach((x) => {
      if (x.dataset.variant === v.dataset.variant || ids.includes(x.dataset.variant)) return;
      ids.push(x.dataset.variant);
      total += Number(x.dataset.price);
    });
    return { id: v.dataset.variant, available: v.dataset.available !== 'false', extras: ids, total, title: plan.dataset.title };
  }

  function render() {
    if (busy) return;
    const s = state();
    if (!s) return;
    btn.disabled = !s.available;
    btn.textContent = s.available ? label + ' – ' + fmt(s.total) : 'Slutsåld';
    if (eyebrow) eyebrow.textContent = s.title;
    if (sPrice) sPrice.textContent = fmt(s.total);
    if (sName) sName.textContent = s.title + (s.extras.length ? ' + ' + s.extras.length + ' tillägg' : '');
  }

  root.addEventListener('change', render);
  render();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (busy) return;
    const s = state();
    if (!s || btn.disabled) return;
    busy = true;
    const items = [{ id: Number(s.id), quantity: 1 }].concat(s.extras.map((id) => ({ id: Number(id), quantity: 1 })));
    const idList = items.map((i) => String(i.id));
    btn.disabled = true;
    btn.textContent = 'Lägger till…';
    if (sBtn) sBtn.disabled = true;

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: 1 })),
      promise: deferred.promise
    }));

    try {
      const body = { items };
      if (sectionIds.length) body.sections = sectionIds.join(',');
      const res = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      });
      const data = await res.json();
      if (data && data.status) throw new Error(data.description || data.message || 'Kunde inte lägga till');
      await capQuantities(idList);
      const cart = await refreshCart();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'mm-buy', sections: data.sections, itemCount: items.length, didError: false }
      });
      btn.textContent = 'Tillagd ✓';
      setTimeout(() => { busy = false; if (sBtn) sBtn.disabled = false; render(); }, 1600);
    } catch (error) {
      console.warn('[mm-buy] add to cart failed', error);
      try {
        await capQuantities(idList);
        const cart = await refreshCart();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'mm-buy', itemCount: items.length, didError: true }
        });
      } catch (e) { deferred.reject(e); }
      btn.textContent = 'Försök igen';
      setTimeout(() => { busy = false; if (sBtn) sBtn.disabled = false; render(); }, 2200);
    }
  });

  if (sBtn) sBtn.addEventListener('click', () => {
    if (busy) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else btn.click();
  });

  if (sticky && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    });
    io.observe(btn);
  }

  const track = root.querySelector('.mm-gal');
  const dots = root.querySelectorAll('.mm-gal__dot');
  if (track && dots.length > 1) {
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
    }, { passive: true });
  }
}

document.querySelectorAll('[data-mm-buy]').forEach(init);
document.addEventListener('shopify:section:load', (e) => {
  const r = e.target && e.target.querySelector && e.target.querySelector('[data-mm-buy]');
  if (r) init(r);
});
